// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cl5c-","right":"styles_right__3AcKv"};